export const hasCombiner = (fragment) => {
    const combinersList = ['oneOf', 'allOf', 'anyOf'];

    for (const key in fragment) {
        if (combinersList.includes(key)) return true;
    }
    return false;
};
